// Copyright (c) 2026 Theiagen Genomics. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use is prohibited.
// Named constants used throughout the core pipeline.

export const Angles = {
  Degrees0: 0,
  Degrees45: Math.PI * 0.25,
  Degrees90: Math.PI * 0.5,
  Degrees180: Math.PI,
  Degrees270: Math.PI * 1.5,
  Degrees360: Math.PI * 2,
};

export const EmptyArray = Object.freeze([]);

export const EmptyObject = Object.freeze({});

export const TreeTypes = {
  Circular: "cr",
  Diagonal: "dg",
  Hierarchical: "hr",
  Radial: "rd",
  Rectangular: "rc",
};

export const Shapes = {
  Chevron: "chevron",
  ChevronInverted: "chevron-inverted",
  ChevronLeft: "chevron-left",
  ChevronRight: "chevron-right",
  Circle: "circle",
  Cross: "cross",
  Diamond: "diamond",
  Dot: "dot",
  DoubleChevron: "double-chevron",
  DoubleChevronInverted: "double-chevron-inverted",
  DoubleChevronLeft: "double-chevron-left",
  DoubleChevronRight: "double-chevron-right",
  Heptagon: "heptagon",
  HeptagonInverted: "heptagon-inverted",
  Heptagram: "heptagram",
  HeptagramInverted: "heptagram-inverted",
  Hexagon: "hexagon",
  Hexagram: "hexagram",
  Octagon: "octagon",
  Octagram: "octagram",
  Pentagon: "pentagon",
  PentagonInverted: "pentagon-inverted",
  Pentagram: "pentagram",
  PentagramInverted: "pentagram-inverted",
  Plus: "plus",
  Square: "square",
  Star: "pentagram",
  StarInverted: "pentagram-inverted",
  Tetragram: "tetragram",
  Triangle: "triangle",
  TriangleInverted: "triangle-inverted",
  TriangleLeft: "triangle-left",
  TriangleRight: "triangle-right",
  Wye: "wye",
  WyeInverted: "wye-inverted",
};
